import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import { defaultStartDate, rotatedBarAxis, emptyBarChart } from "./chartUtils";

export default class AverageHandleTimeChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: emptyBarChart("Total Chats", "#662C8F"),
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    const chartData = emptyBarChart("Total Chats", "#662C8F");
    try {
      const res = await clientService.getAverageHandleTime(
        startDate,
        endDate,
        [],
      );
      if (res.data && res.data.result && res.data.result.length) {
        chartData.columns = [
          ["x", ...res.data.result.map((m) => m.name)],
          [
            "Average Handle Time",
            ...res.data.result.map((m) => m.totalChats),
          ],
        ];
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({ chartData });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="inline"
        />
        <div className="col col-12 col-sm-12 col-lg-12" />
        <AnalyticsChartCard
          title="Average Handle Time"
          cardClassName="box-3rd card card101"
          wrapCol={false}
        >
          <C3Chart
            size={{ height: 500 }}
            bar={{ width: 50 }}
            padding={{ left: 100 }}
            data={this.state.chartData}
            axis={rotatedBarAxis}
            legend={{ show: true }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
